<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div>
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-10">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">Replenish</h4>
                </div>
                <div class="flex items-center">
                    <vs-button @click="fetchData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
                    <vs-button :to="{ name: 'replenish-add'} " class="btn mb-4 md:mb-0 mr-1" icon="add">Add</vs-button>
                    <vs-button class="mb-4 md:mb-0 mr-1" icon="remove_red_eye" @click="handleView">View</vs-button>
                    <vs-button class="mb-4 md:mb-0 mr-1" icon="filter_list" @click="handleFilter">Filter</vs-button>
                    <vs-button @click="handleExport" class="btn mb-4 md:mb-0 mr-1" icon="import_export">Export</vs-button>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="handleView"
                :animateRows="false"
                :floatingFilter="false"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination
                :total="totalPage"
                v-model="currentPage"
                :max="7"
            ></vs-pagination>
        </vx-card>
        <!-- <vs-prompt buttons-hidden title="Filter" :active.sync="stocktransfer.filtershow">
            <div class="con-exemple-prompt">
                <div class="vx-col w-full mb-2">
                    <vs-input class="w-full" v-model="stocktransfer.filter.transfer_id" label="Transfer ID"/>
                </div>
                <div class="vx-col w-full mb-2">
                    <vs-input class="w-full" v-model="stocktransfer.filter.reference" label="Reference"/>
                </div>
                <label class="vs-input--label">Posting Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr
                            class="vx-col  w-full p-2"
                            v-model="stocktransfer.filter.posting_date"
                        />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">
                        To
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr
                            class="vx-col w-full p-2"
                            v-model="stocktransfer.filter.posting_date_to"
                        />
                    </vs-col>
                </vs-row>
                <label class="vs-input--label">Transaction Type</label>
                <vx-input-group class="mb-3">
                    <vs-input v-model="stocktransfer.filter.transaction_type"/>
                    <template slot="append">
                        <div class="append-text btn-addon">
                            <vs-button
                                size="small"
                                color="primary"
                                icon-pack="feather"
                                icon="icon-search"
                                type="border"
                                @click="handlepopuptransactiontype"
                            ></vs-button>
                        </div>
                    </template>
                </vx-input-group>
                <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
                    <vs-button color="primary" @click="handlestocktransferfilter">Search</vs-button>
                </vs-row>
            </div>
        </vs-prompt> -->
    </div>
</template>
<script>
import vSelect from "vue-select";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            data: [],
            filter: {},
            selectedId: null,
            totalPage: 0,
            gridApi: null,
            columnApi: null,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            gridOptions: {},
            columnDefs: [
                {
                    headerName: "Replenish ID",
                    field: "id",
                    width: 120
                },
                {
                    headerName: "Reference",
                    field: "reference",
                    width: 120
                },
                {
                    headerName: "Client ID",
                    field: "client_code",
                    width: 120
                },
                {
                    headerName: "Replenish Date",
                    field: "replenish_date",
                    width: 120
                },
                {
                    headerName: "Type",
                    field: "replenish_type",
                    width: 120
                }
            ],

            warehouse: {
                data: [],
            },
            client: {
                data: [],
            }
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridOptions.api.getSelectedRows()
            var selectedRowsString = ''
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                selectedRowsString += ', '
                }
                selectedRowsString += selectedRow.id
            })
            this.selectedId = selectedRowsString
        },
        // Handle Button
        handleView() {
            this.$router.push({
                name: "replenish-view",
                params: {
                    id: this.selectedId
                }
            });
        },
        handleFilter() {

        },
        handleExport() {
            console.log("handleExport");
        },
        fetchData() {
            this.isLoading = true
            Promise.all([
                this.$http.post('inventories/replenish?page=' + this.currentPage, this.filter)
            ])
            .then(this.$http.spread((res => {
                this.isLoading = false
                this.data = res.data.data
                this.totalPage = res.data.last_page
                this.dataTotal = res.data.total
                this.dataFrom = res.data.from
                this.dataTo = res.data.to
            })))
            .catch(error => this.handleError(error))
        },
    },
    computed: {},
    mounted() {
        this.fetchData();
    },
    beforeMount() {
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>